













import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import MfaSettings from "@/shared/components/MfaSettings.vue";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import OktaFactorSettings from "@/shared/components/OktaFactorSettings.vue";
import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { AuthType } from "@/shared/types";
import { useImpersonatorStore } from "@/shared/store/impersonator";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    SettingsNavigation,
    MfaSettings,
    SettingsHeader,
    OktaFactorSettings
  }
})
export default class Security extends Vue {
  impersonatorStore = useImpersonatorStore();
  userStore = useUserStore();

  showOktaFactors () {
    if (this.impersonatorStore.impersonationIsActive) {
      return this.impersonatorStore.impersonationAuthType.toLocaleLowerCase() === AuthType.Okta.toLocaleLowerCase();
    } else {
      return this.userStore.authType === AuthType.Okta;
    }
  }
}
